import { useLocation } from 'react-router'

/**
 * @param defaultValue Does not modify the query parameters in the url
 */
export default function useSearchParams<T = Record<string, string | number>>(
  defaultValue?: T,
): Partial<T> & { paramsInstance: URLSearchParams } {
  const location = useLocation()

  const paramsInstance = new URLSearchParams(location.search)

  const params: Partial<T> = defaultValue ?? {}

  for (const [key, value] of paramsInstance.entries()) {
    params[key] = value
  }

  return {
    ...params,
    paramsInstance,
  }
}
